/**
 * Auth Service - API key storage and management
 * Uses localStorage to persist API key across sessions
 */

const API_KEY_STORAGE_KEY = 'crm_poker_api_key'
const PARTNER_STORAGE_KEY = 'crm_poker_partner'

/**
 * Get stored API key
 * @returns {string|null} API key or null if not stored
 */
export function getApiKey() {
  return localStorage.getItem(API_KEY_STORAGE_KEY)
}

/**
 * Store API key in localStorage
 * @param {string} apiKey - The API key to store
 */
export function setApiKey(apiKey) {
  localStorage.setItem(API_KEY_STORAGE_KEY, apiKey)
}

/**
 * Remove API key from storage (logout)
 */
export function clearApiKey() {
  localStorage.removeItem(API_KEY_STORAGE_KEY)
  localStorage.removeItem(PARTNER_STORAGE_KEY)
}

/**
 * Get stored partner info
 * @returns {Object|null} Partner object or null
 */
export function getStoredPartner() {
  const stored = localStorage.getItem(PARTNER_STORAGE_KEY)
  if (!stored) return null
  try {
    return JSON.parse(stored)
  } catch {
    return null
  }
}

/**
 * Store partner info in localStorage
 * @param {Object} partner - Partner data from /api/auth/me
 */
export function setStoredPartner(partner) {
  localStorage.setItem(PARTNER_STORAGE_KEY, JSON.stringify(partner))
}

/**
 * Check if user is authenticated (has API key)
 * @returns {boolean}
 */
export function isAuthenticated() {
  return !!getApiKey()
}
